import React, { Component } from 'react'
import '../stylesheets/main.scss'
import link from './Tags'

class Menu extends Component{

	constructor(props){
		super(props)

		this.state = {
			position: [],
			menus: [
				{
					id : 1,
					link: "#home",
					title: "Home",
					tagtitle: "home",
					tagaction: "menu-superior"
				},
				{
					id : 2,
					link: "#sobre",
					title: "Sobre",
					tagtitle: "sobre",
					tagaction: "menu-superior"
				},
				{
					id : 3,
					link: "#onde-estamos",
					title: "Onde estamos",
					tagtitle: "onde-estamos",
					tagaction: "menu-superior"
				},
				{
					id : 4,
					link: "#carregamos",
					title: "O que carregamos",
					tagtitle: "o-que-carregamos",
					tagaction: "menu-superior"
				},
				{
					id : 5,
					link: "#diario-de-bordo",
					title: "Diário de bordo",
					tagtitle: "diario-de-bordo",
					tagaction: "menu-superior"
				}
			]
		}
	}

	componentWillMount(){
		fetch('https://www.serasaconsumidor.com.br/serasaitinerante/manager/api/v1/position')
			.then(response => response.json())
	      	.then(data => this.setState({ position: data.city }));
	}

	render(){
		const itens = this.state.menus.map((item) => {
					      return (
						      		<li key={item.id}>
										<a href={item.link} onClick={(e) => link(item, e)} className="c-title c-title--size-small c-title--family-regular c-title--color-white c-title--align-center" >
											{item.title}
										</a>
									</li>
					      		)
					    	})

		return (
			<div className="c-menu" >

				<ul className="c-menu--list">
					<li>
						<h1 className="c-title c-title--weight-regular c-title--color-white c-title--align-center">
							<img src={ process.env.PUBLIC_URL + "/images/logotipo.png" } alt="" />
						</h1>
						<h2 className="c-title c-title--size-small c-title--weight-regular c-title--color-white c-title--align-center o-uppercase">
							Estamos em <span className="c-title c-title--weight-bold">{ this.state.position }</span>
						</h2>
					</li>
					<li>
						<ul className="c-menu--list c-menu--list-spacing c-menu--list-desk">
							{ itens }
						</ul>
					</li>
				</ul>
		        
	      	</div>
		)
	}

}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js